export default __webpack_public_path__ + "static/media/portfolio.068bb6b3.png";